const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the comment count component
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {Saml} CompanyIntegrations injected to gain access to the Saml resource
 */
app.directive('bambooSettings', ['Application', 'CompanyIntegrations', '$translate', function(Application, CompanyIntegrations, $translate) {
    return {
      restrict: "E",
      replace: true,
      scope: {
      },
      template: require('../../templates/directives/bamboo-settings.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          function defaultBamboo() {
            return {
              subdomain: '',
              apikey: '',
              provisioning_status: 'inviting',
              mute_notifications: true,
              admin_list: [],
              creator_list: [],
              filter_division_action: 'nothing',
              filter_division_list: []
            };
          }
          self.activeTab = 'edit';
          self.original = null;
          self.integration = {bamboo: defaultBamboo()};
          self.loading = false;
          self.admin_email_field = '';
          self.creator_email_field = '';
          self.division_field = '';
          self.cancel = function() {
            if (self.original) {
              self.integration = angular.copy(self.original);
            } else {
              self.integration = {_id: self.integration && self.integration._id, bamboo: defaultBamboo()};
            }
            self.activeTab = 'edit';
          };
          self.add_admin_email = function() {
            if (self.admin_email_field) {
              self.integration.bamboo.admin_list = self.integration.bamboo.admin_list || [];
              self.integration.bamboo.creator_list = self.integration.bamboo.creator_list || [];
              var admin_emails = self.admin_email_field.toLowerCase().split(',');
              admin_emails.forEach(function(admin_email) {
                if (self.integration.bamboo.creator_list.length) {
                  self.integration.bamboo.creator_list = self.integration.bamboo.creator_list.filter(function(email) {
                    return email !== admin_email;
                  });
                }
                if (self.integration.bamboo.admin_list.length) {
                  self.integration.bamboo.admin_list = self.integration.bamboo.admin_list.filter(function(email) {
                    return email !== admin_email;
                  });
                }
                self.integration.bamboo.admin_list.push(admin_email);
              });
              self.admin_email_field = '';
            }
          };
          self.add_division = function() {
            self.integration.bamboo.filter_division_list = self.integration.bamboo.filter_division_list || [];
            if (self.integration.bamboo.filter_division_list.length) {
              self.integration.bamboo.filter_division_list = self.integration.bamboo.filter_division_list.filter(function(division) {
                return division !== self.division_field.toLowerCase();
              });
            }
            if (self.division_field) {
              self.integration.bamboo.filter_division_list.push(self.division_field.toLowerCase());
              self.division_field = '';
            }
          };
          self.add_creator_email = function() {
            if (self.creator_email_field) {
              self.integration.bamboo.admin_list = self.integration.bamboo.admin_list || [];
              self.integration.bamboo.creator_list = self.integration.bamboo.creator_list || [];
              var creator_emails = self.creator_email_field.toLowerCase().split(',');
              creator_emails.forEach(function(creator_email) {
                if (self.integration.bamboo.creator_list.length) {
                  self.integration.bamboo.creator_list = self.integration.bamboo.creator_list.filter(function(email) {
                    return email !== creator_email;
                  });
                }
                if (self.integration.bamboo.admin_list.length) {
                  self.integration.bamboo.admin_list = self.integration.bamboo.admin_list.filter(function(email) {
                    return email !== creator_email;
                  });
                }
                self.integration.bamboo.creator_list.push(creator_email);
              });
              self.creator_email_field = '';
            }
          };
          self.createOrUpdate = function() {
            if (!self.integration) {
              return;
            }
            // Only send the bamboo subdocument — the API $sets whatever it receives,
            // and the model may hold the status payload (slack/zoom booleans).
            var payload = {bamboo: self.integration.bamboo};
            var onSave = function(data) {
              self.integration = {_id: data._id, bamboo: Object.assign(defaultBamboo(), data.bamboo || {})};
              self.original = angular.copy(self.integration);
              self.loading = false;
              self.hasBamboo = !!(self.integration.bamboo.subdomain && self.integration.bamboo.apikey);
              Application.messaging.addMessage({type: 'success', text: self.translations['overview.settings.integrations_bambooSaved'], duration: 5});
            };
            var onError = function(error) {
              self.loading = false;
              console.log('Error occured getting company integration ', error);
              Application.messaging.addMessage({type: 'error', text: self.translations['overview.settings.integrations_bambooError'], duration: 5});
            };
            self.loading = true;
            if (!self.integration._id) {
              CompanyIntegrations.create({}, payload, onSave, onError);
            } else {
              CompanyIntegrations.update({subresource: self.integration._id.toString()}, payload, onSave, onError);
            }
          };
          self.initialize = function() {
            self.loading = true;
            CompanyIntegrations.status({}, function(data) {
              self.loading = false;
              // Keep _id even when bamboo isn't configured yet so a save routes
              // through update instead of creating a duplicate integrations doc.
              self.integration = {
                _id: data && data._id,
                bamboo: Object.assign(defaultBamboo(), (data && data.bamboo) || {})
              };
              self.hasBamboo = !!(self.integration.bamboo.subdomain && self.integration.bamboo.apikey);
              self.original = self.hasBamboo ? angular.copy(self.integration) : null;
            }, function(error) {
              self.loading = false;
              console.log('Error occured getting company integration ', error);
              Application.messaging.addMessage({type: 'error', text: self.translations['overview.settings.integrations_bambooError'], duration: 5});
            });

          };
          $translate([
            'overview.settings.integrations_bambooSaved',
            'overview.settings.integrations_bambooError'
          ]).then(function(translations) {
            self.translations = translations;
            self.initialize();
          });
        }],
      controllerAs: 'bamboo'
    };
  }]);
